import React from "react";

import TabsPage from '../TabsPage';
import Table from "components/Table";
import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";

import './index.less';
import './themes/default.less';

export default class Notes extends TabsPage {

    constructor(props) {
        super(props);

        this.tableMap = {
            createdTime: {
                label: "client.date",
                type: "dateTime",
                callback: this.renderDateCell.bind(this),
            },
            source: {
                label: "Канал",
                type: "select",
                store: "sourceComment",
                nameKey: "name",
            },
            createdBy: {
                label: "roles.employee",
                type: "doctor",
            },
            /*clinicId: {
                label: "login.clinic",
            },*/
            comment: {
                label: "main.comment",
            },
            actions: {
                label: "main.actions",
                size: 35,
                callback: this.renderActionCell.bind(this),
                hideLabel: true,
            },
        };

        this.state = {
            ...this.state,
            items: []
        };
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.getData();
    }

    renderDateCell(value) {
        return this._helper.date.toStr(this._helper.date.toLocal(value), "DD MMMM YYYY HH:mm");
    }

    renderActionCell(value, it, { id, comment, source }) {

        const items = [
            { name: "main.edit", onClick: this.openTransferDialog.bind(this, { id, comment, source }) },
            { name: "client.delete", onClick: this.deleteConfirm.bind(this, id) },
        ];

        return (<ButtonIconSelect
            translate={true}
            items={items}
        />);
    }

    openTransferDialog(info) {
        this.props.openDialog("changeNote", info, this.createNote.bind(this), "general");
    }

    deleteConfirm(id) {
        this._helper.confirm(
            { title: "Удаление комментария", message: this.tr("Вы удаляете комментарий. Он пропадет из карты пациента - Подтвердить?") },
            this.onDeleteComment.bind(this, id)
        );
    }

    async onDeleteComment(id) {
        this._helper.showLoading();
        await this._request.clientNotes.delete(id);
        this._helper.hideLoading();
        this.refresh();
    }

    async getData() {
        this._helper.showLoading();
        const resp = await this._request.clientNotes.getAllForClient(this.props.info.id);
        this._helper.hideLoading();
        const items = (resp?.data || []).map(it => ({ ...it, source: +it.source }));
        this.setState({ items });
    }

    createNoteDialog() {
        this.props.openDialog("changeNote", {}, this.createNote.bind(this), "general");
    }

    async createNote({ comment, source, id }) {
        this._helper.showLoading();
        if (id) {
            await this._request.clientNotes.update(id, {
                source,
                comment
            });
        } else {
            await this._request.clientNotes.add({
                source,
                clientId: this.props.info.id,
                comment
            });
        }

        this._helper.hideLoading();
        this.refresh();
    }

    renderContent() {
        const { items } = this.state;
        return (<div className="tabsPage flex col gap16 flex1 minH0 pos rel">
            <div className="w0" style={{ width: "220px" }}>
                <Button
                    type={"secondary"}
                    size={"small"}
                    label={"Добавить комментарий"}
                    onClick={this.createNoteDialog.bind(this)}
                />
            </div>
            <Table
                map={this.tableMap}
                items={items}
            />
        </div>);
    }
}
